export default __webpack_public_path__ + "static/media/github_footer.46d34ee1.svg";